import type { VaultItem } from '@heybesafe/shared';
import { SafeItemRow } from '../../components/SafeItemRow';
import { FamilyContactRow } from '../../components/FamilyContactRow';

/**
 * One pane of the Family overview's shared items. The overview splits shared
 * items into a Sites pane and a Contacts pane; each renders through this
 * component with its own title and empty copy. Contacts use the contact row
 * (avatar + phone/email); everything else uses the login-style SafeItemRow, so
 * the Sites pane looks identical to the personal Safe.
 */
export function FamilySafeList({
  items,
  title = 'Family Safe',
  emptyMessage = 'No shared items yet. Share a login with the family from any personal item.',
}: {
  items: VaultItem[];
  title?: string;
  emptyMessage?: string;
}) {
  return (
    <section className="bg-hbs-surface border border-hbs-border rounded-hbs-xl">
      <header className="flex items-center justify-between px-4 py-3 border-b border-hbs-border">
        <h2 className="text-xs uppercase tracking-wide text-hbs-text-mute">{title}</h2>
      </header>

      {items.length === 0 ? (
        <div className="px-4 py-6 text-sm text-hbs-text-mute text-center">
          {emptyMessage}
        </div>
      ) : (
        <ul className="flex flex-col gap-px p-2">
          {items.map((item) => (
            <li key={item.id}>
              {item.type === 'contact'
                ? <FamilyContactRow item={item} />
                : <SafeItemRow item={item} />}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
